/**
 * Replace the rating field with stars
 */
import clickHander from './clickHandler';

/**
 * Replace the rating field with stars for the selected element
 *
 * @param element
 */
const showStars = ( element: HTMLElement ) => {
	element.style.display = 'none';

	const stars = document.createElement( 'p' );
	stars.classList.add( 'amx-stars' );

	for ( let i = 0; i < 5; i++ ) {
		const star = document.createElement( 'a' );
		star.classList.add( 'amx-star-' + ( i + 1 ) );
		star.innerHTML = ( i + 1 ).toString();
		star.setAttribute( 'href', '#' );
		star.addEventListener( 'click', clickHander );
		stars.appendChild( star );
	}

	element.parentElement?.insertBefore( stars, element );
};

export default showStars;
